// usePortfolioExchange.js
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  selectExchanges,
  selectExchangeLoading,
  selectExchangeError,
  selectExchangePortfolios
} from '../../store/slices/exchange.slice';
import { fetchContentGroupByName } from '../../api/contentGroups';
import { fetchPortfoliosInBatches } from "../../api/portfolioApi";


const usePortfolioExchange = (exchangeId = null) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const exchanges = useSelector(selectExchanges);
  const loading = useSelector(selectExchangeLoading);
  const error = useSelector(selectExchangeError);
  const exchangeType = useSelector(state => state.exchange.exchangeType);
  const portfolios = useSelector(state =>
    exchangeId ? selectExchangePortfolios(state, exchangeId) : []
  );

  useEffect(() => {
    if (!exchanges || exchanges.length === 0) {
      dispatch(fetchContentGroupByName('portfolioExchanges'));
    }
  }, [dispatch, exchanges]);

  useEffect(() => {
    if (exchangeId && exchanges) {
      const exchange = exchanges.find(e => e.fields.name === exchangeId);
      if (exchange?.fields?.portfolioIds?.length > 0) {
        dispatch(fetchPortfoliosInBatches({
          portfolioIds: exchange.fields.portfolioIds,
          userId: localStorage.getItem('userId'),
          userObjects: [],
          batchSize: 50
        }));
      }
    }
  }, [dispatch, exchangeId, exchanges]);

  const navToExchange = (exchangeName) => {
    if (!exchanges) return false;

    const exchange = exchanges.find(e =>
      e.fields.name.toLowerCase() === exchangeName.toLowerCase()
    );

    if (exchange) {
      navigate(`/portfolios/exchange/${exchange.fields.name}`);
      return true;
    }

    return false;
  };

  return {
    exchanges,
    exchangeType,
    loading,
    error,
    portfolios,
    navToExchange,
    refetch: () => dispatch(fetchContentGroupByName('portfolioExchanges')),
    refetchPortfolios: (exchangeName) => {
      const exchange = exchanges?.find(e => e.fields.name === exchangeName);
      if (exchange?.fields?.portfolioIds) {
        return dispatch(fetchPortfoliosInBatches({
          portfolioIds: exchange.fields.portfolioIds,
          userId: localStorage.getItem('userId'),
          userObjects: [],
          batchSize: 50
        }));
      }
    }
  };
};

export default usePortfolioExchange;